














































































































































































































































































































import {ProductPriority, SelectBox} from '@/interfaces/global-data'
import {
  DailyQuotas,
  IdAndName,
  RevaluationQuotasOfStoreFormat,
  RevaluationQuotasOfTradingNetwork,
  RevaluationQuotasToSave, TaskInfoFilterType,
} from '@/interfaces/server-data'
import Http from '@/mixins/http'
import Toast from '@/mixins/toast';
import {Component, Mixins} from 'vue-property-decorator'
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue'

@Component({
    components: {
        SwitchWithLabel,
    },
    methods: {
        replaceDecimalSubStrFormatter(value) {
            if (value == null) {
                return null
            } else {
                const result = parseFloat(value.replace(/(\d)(?=(\d{3})+(\D|$))/g, '$1').replace(',', '.'));
                return String(result).substring(0, 6)
            }
        },
    },
})
export default class RevaluationQuotas extends Mixins(Toast, Http) {
    defaultQuotas = {
        priorityRule: {priority: ProductPriority.MARGIN_CHANGE, competitorsAndKviFirst: false, regulatedProductsFirst: false, ignoreEmptyRemainsInQuotas: true},
        dailyQuotas: {
            monday: -1,
            tuesday: -1,
            wednesday: -1,
            thursday: -1,
            friday: -1,
            saturday: -1,
            sunday: -1,
        },
    }
    quotasTableFields = [
        {key: 'tradingNetwork', label: this.$t('regular.columns.tradingCompany') as string, thStyle: { width: '13%' }},
        {key: 'storeFormat', label: this.$t('regular.columns.formatChannel') as string, thStyle: { width: '87%' }},
    ]
    newTableFields: any[] = [
        {
            dataIndex: 'tradingNetworkId',
            title: this.$t('regular.columns.tradingCompany') as string,
            scopedSlots: { customRender: 'trading' },
            width: 200,
        },
        {dataIndex: 'storeFormatId', title: this.$t('regular.columns.formatChannel') as string, scopedSlots: { customRender: 'storeFormatId' }, width: 200},
        {dataIndex: 'priorityRules', title: this.$t('regular.columns.prioritizationMethod') as string, scopedSlots: { customRender: 'priorityRules' }, width: 330},
        {dataIndex: 'monday', title: this.$t('regular.schedule.mon') as string, scopedSlots: { customRender: 'monday' }, width: 120},
        {dataIndex: 'tuesday', title: this.$t('regular.schedule.tue') as string, scopedSlots: { customRender: 'tuesday' }, width: 120},
        {dataIndex: 'wednesday', title: this.$t('regular.schedule.wed') as string, scopedSlots: { customRender: 'wednesday' }, width: 120},
        {dataIndex: 'thursday', title: this.$t('regular.schedule.thu') as string, scopedSlots: { customRender: 'thursday' }, width: 120},
        {dataIndex: 'friday', title: this.$t('regular.schedule.fri') as string, scopedSlots: { customRender: 'friday' }, width: 120},
        {dataIndex: 'saturday', title: this.$t('regular.schedule.sat') as string, scopedSlots: { customRender: 'saturday' }, width: 120},
        {dataIndex: 'sunday', title: this.$t('regular.schedule.sun') as string, scopedSlots: { customRender: 'sunday' }, width: 120},
        {dataIndex: 'actions', title: '', scopedSlots: { customRender: 'actions' }, width: 100},
    ];

    quotasTable: RevaluationQuotasOfTradingNetwork[] = []
    tradingNetworkOptions: Array<SelectBox<number>> = []
    quotaValidationMessage = this.$t('regular.validation.numberRange0to999999') as string
    waitingToBeSaved = false

    priorityOptions = [
        {value: ProductPriority.MARGIN_CHANGE, label: this.$t('regular.strategies.byGrossIncome') as string},
        {value: ProductPriority.REVENUE_CHANGE, label: this.$t('regular.strategies.byTurnover') as string},
    ]

    mounted() {
        this.getTradingNetworks()
        this.getQuotas()
    }

    private getTradingNetworks() {
        this.httpLoadTradingNetworks(false).then((r) => {
            this.tradingNetworkOptions = r.data.map((tn) => {
                return {value: tn.id, label: tn.tradingName}
            })
        })
    }

    private getFormatsByTradingNetwork(tnQuotas: RevaluationQuotasOfTradingNetwork) {
      const params = {
        type: TaskInfoFilterType.format,
        tradingId: tnQuotas.tradingNetworkId!,
        categories: null,
        groups: null,
        subcategory: null,
        segments: null,
        storeFormat: null,
        storeCluster: null,
        storeRegion: [],
        byReports: false,
      }
        this.httpGetProductInfo(params).then((r) => {
            tnQuotas.availableFormats = r.data.storeFormat
            tnQuotas.availableFormats.unshift({id: -1, name: this.$t('regular.common.all') as string})
            tnQuotas.quotasOfFormats[0].storeFormatId = -1
        })
    }

    private mapToOptions(idAndNameArray: IdAndName[]): Array<SelectBox<number>> {
        return idAndNameArray.map((item) => {
            return {value: item.id, label: item.name}
        })
    }

    private addTradingNetworkQuotas() {
        const quotas: RevaluationQuotasOfTradingNetwork = {
            tradingNetworkId: null,
            quotasOfFormats: [{
                storeFormatId: null,
                priorityRule: {priority: ProductPriority.MARGIN_CHANGE, competitorsAndKviFirst: false, regulatedProductsFirst: false, ignoreEmptyRemainsInQuotas: true},
                dailyQuotas: {...this.defaultQuotas.dailyQuotas},
            }],
            availableFormats: [],
        }
        this.quotasTable.push(quotas);
    }

    private addStoreFormatQuotas(tnQuotas: RevaluationQuotasOfTradingNetwork) {
        const formatQuotas: RevaluationQuotasOfStoreFormat = {
            storeFormatId: null,
            priorityRule: {priority: ProductPriority.MARGIN_CHANGE, competitorsAndKviFirst: false, regulatedProductsFirst: false, ignoreEmptyRemainsInQuotas: true},
            dailyQuotas: {...this.defaultQuotas.dailyQuotas},
        }
        tnQuotas.quotasOfFormats.push(formatQuotas)
    }

    private getQuotas() {
        this.httpGetRevaluationQuotas()
            .then((r) => {
                this.quotasTable = this.extractDefault(r.data)
            })
    }

    private extractDefault(quotas: RevaluationQuotasOfTradingNetwork[]): RevaluationQuotasOfTradingNetwork[] {
        const defaultQuotas = quotas.filter((tn) => tn.tradingNetworkId === -1)[0].quotasOfFormats[0]
        this.defaultQuotas.priorityRule = defaultQuotas.priorityRule
        this.defaultQuotas.dailyQuotas = defaultQuotas.dailyQuotas
        return quotas.filter((tn) => tn.tradingNetworkId !== -1)
    }

    private saveQuotas() {
        this.waitingToBeSaved = true
        const toSave: RevaluationQuotasToSave[] = [{
            tradingNetworkId: -1,
            storeFormatId: -1,
            priorityRule: this.defaultQuotas.priorityRule,
            dailyQuotas: this.defaultQuotas.dailyQuotas,
        }]
        this.quotasTable.forEach((tn) => {
            tn.quotasOfFormats.forEach((sf) => {
                if (tn.tradingNetworkId !== null && sf.storeFormatId !== null) {
                    toSave.push({
                        tradingNetworkId: tn.tradingNetworkId,
                        storeFormatId: sf.storeFormatId,
                        priorityRule: sf.priorityRule,
                        dailyQuotas: sf.dailyQuotas,
                    })
                }
            })
        })
        this.httpSaveRevaluationQuotas(toSave)
            .then((r) => {
                this.quotasTable = this.extractDefault(r.data)
                this.showInfo(this.$t('regular.notifications.quotasSaved') as string)
                this.waitingToBeSaved = false
            })
            .catch(() => this.waitingToBeSaved = false)
    }

    private deleteQuotas(
        quotasOfFormat: RevaluationQuotasOfStoreFormat,
        quotasOfTradingNetwork: RevaluationQuotasOfTradingNetwork,
    ) {
        if (quotasOfFormat.storeFormatId === -1 || quotasOfTradingNetwork.quotasOfFormats.length === 1) {
            this.quotasTable = this.quotasTable.filter((tn) => tn !== quotasOfTradingNetwork)
        } else {
            quotasOfTradingNetwork.quotasOfFormats =
                quotasOfTradingNetwork.quotasOfFormats.filter((sf) => sf !== quotasOfFormat)
        }
    }

    private getQuotaForDay(dailyQuotas: DailyQuotas, day: string): number {
        return Object.entries(dailyQuotas).filter(([key]) => key === day)[0][1] as number
    }

    private validateQuota(value: number | string | null): boolean {
        return value !== null && value !== '' && value >= 0 && value <= 999999;
    }

    private validateQuotas(dailyQuotas: DailyQuotas): boolean {
        return this.validateQuota(dailyQuotas.monday) &&
            this.validateQuota(dailyQuotas.tuesday) &&
            this.validateQuota(dailyQuotas.wednesday) &&
            this.validateQuota(dailyQuotas.thursday) &&
            this.validateQuota(dailyQuotas.friday) &&
            this.validateQuota(dailyQuotas.saturday) &&
            this.validateQuota(dailyQuotas.sunday)
    }

    get filledCorrectly(): boolean {
        return this.allQuotaValuesCorrect && this.allSelected && this.allUnique &&
            this.allHaveRequiredOption
    }

    get allQuotaValuesCorrect(): boolean {
        let isCorrect = true
        if (!this.validateQuotas(this.defaultQuotas.dailyQuotas)) { isCorrect = false }
        this.quotasTable.forEach((tn) => {
            tn.quotasOfFormats.forEach((sf) => {
                if (!this.validateQuotas(sf.dailyQuotas)) { isCorrect = false }
            })
        })
        return isCorrect
    }

    get allSelected(): boolean {
        let isCorrect = true
        this.quotasTable.forEach((tn) => {
            const hasNull = tn.quotasOfFormats.findIndex((sf) => sf.storeFormatId === null) > -1
            if (tn.tradingNetworkId === null || hasNull) { isCorrect = false }
        })
        return isCorrect
    }

    get allUnique(): boolean {
        let isCorrect = true
        const tradingNetworkIds = this.quotasTable.map((tn) => tn.tradingNetworkId)
        if (tradingNetworkIds.length !== new Set(tradingNetworkIds).size) { isCorrect = false }

        this.quotasTable.forEach((tn) => {
            const formatIds = tn.quotasOfFormats.map((sf) => sf.storeFormatId)
            if (formatIds.length !== new Set(formatIds).size) { isCorrect = false }
        })
        return isCorrect
    }

    get allHaveRequiredOption(): boolean {
        let isCorrect = true
        this.quotasTable.forEach((tn) => {
            if (tn.quotasOfFormats.findIndex((sf) => sf.storeFormatId === -1) === -1) { isCorrect = false }
        })
        return isCorrect
    }

    get allLimitsNotExceeded() {
        let isCorrect = true
        this.quotasTable.forEach((tn) => {
            const tradingNetworkQuotas = tn.quotasOfFormats.filter((sf) => sf.storeFormatId === -1)[0]
            const storeFormatQuotas = tn.quotasOfFormats.filter((sf) => sf.storeFormatId !== -1)
            if (storeFormatQuotas.length > 0) {
                Object.keys(this.defaultQuotas.dailyQuotas).forEach((day) => {
                    const tnQuotasForDay = this.getQuotaForDay(tradingNetworkQuotas.dailyQuotas, day)
                    const sfQuotasSumForDay = storeFormatQuotas
                        .map((sf) => this.getQuotaForDay(sf.dailyQuotas, day))
                        .reduce((sum, current) => sum + current, 0)
                    if (tnQuotasForDay - sfQuotasSumForDay < 0) {
                        isCorrect = false
                    }
                })
            }
        })
        return isCorrect
    }

}
